// CB:BEGIN fr-014-shared-header-realtor
import React, { useState } from 'react';
import BottomSheet from './ui/BottomSheet';
import { useDevice } from '../hooks/useDevice';
import { SignedIn, SignedOut, UserButton, SignInButton, useUser } from '@clerk/clerk-react';

interface SharedHeaderRealtorProps {
  onNavigate: (screen: string) => void;
}

const SharedHeaderRealtor: React.FC<SharedHeaderRealtorProps> = ({ onNavigate }) => {
  const { user } = useUser();
  const [menuOpen, setMenuOpen] = useState(false);
  const { isMobileLayout } = useDevice();

  return (
    <div
      className="header sticky top-0 z-40"
      style={{
        background: '#123c3b',
        color: 'white',
        padding: isMobileLayout ? '12px 16px' : '20px 30px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 40,
        WebkitTapHighlightColor: 'transparent',
        touchAction: 'manipulation',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: isMobileLayout ? 12 : 32 }}>
        <div
          className="logo"
          style={{
            fontSize: isMobileLayout ? 20 : 24,
            fontWeight: 600,
            letterSpacing: -0.5,
            cursor: 'pointer',
            lineHeight: 1,
          }}
          onClick={() => onNavigate('landing')}
        >
          CoreBids
        </div>
        {!isMobileLayout && (
          <SignedIn>
            <button
              className="btn btn-secondary"
              style={{ color: 'white', background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)' }}
              onClick={() => onNavigate('realtor-dashboard')}
            >
              Realtor Dashboard
            </button>
          </SignedIn>
        )}
      </div>

      {!isMobileLayout && (
        <div className="nav-buttons" style={{ display: 'flex', gap: 15, alignItems: 'center' }}>
          <SignedIn>
            <span style={{ color: 'rgba(255,255,255,0.8)' }}>
              Welcome, {user?.firstName || user?.fullName?.split(' ')[0] || 'Realtor'}
            </span>
            <UserButton afterSignOutUrl="/" />
          </SignedIn>
          <SignedOut>
            <SignInButton mode="modal">
              <button
                className="btn btn-secondary"
                style={{
                  color: 'white',
                  fontSize: 14,
                  padding: '8px 16px',
                  background: 'rgba(255,255,255,0.15)',
                  border: '1px solid rgba(255,255,255,0.3)',
                }}
              >
                Sign In
              </button>
            </SignInButton>
          </SignedOut>
        </div>
      )}

      {isMobileLayout && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button
            aria-label="Menu"
            onClick={() => setMenuOpen(true)}
            className="btn btn-secondary"
            style={{
              background: 'rgba(255,255,255,0.1)',
              color: 'white',
              border: '1px solid rgba(255,255,255,0.2)',
              padding: '8px 12px',
              borderRadius: 8,
            }}
          >
            ☰
          </button>
        </div>
      )}

      {isMobileLayout && (
        <BottomSheet isOpen={menuOpen} onClose={() => setMenuOpen(false)} title="Menu">
          <div style={{ display: 'grid', gap: 12 }}>
            <SignedIn>
              <button
                className="btn btn-secondary"
                style={{ color: 'black' }}
                onClick={() => {
                  setMenuOpen(false);
                  onNavigate('realtor-dashboard');
                }}
              >
                Realtor Dashboard
              </button>
            </SignedIn>
            <SignedOut>
              <SignInButton mode="modal">
                <button className="btn btn-secondary" style={{ color: 'black' }}>
                  Sign In
                </button>
              </SignInButton>
            </SignedOut>
          </div>
        </BottomSheet>
      )}
    </div>
  );
};

export default SharedHeaderRealtor;
// CB:END fr-014-shared-header-realtor
